export const USER_PROJECTS_CONTEXT_STORAGE_KEY = 'userProjects.selectedProjectId';

/**
 * @param {Array<{ id: string, name?: string }>} activeProjects
 * @param {string | null | undefined} storedProjectId
 * @returns {string | null}
 */
export function resolveDefaultProjectId(activeProjects = [], storedProjectId = null) {
  if (!Array.isArray(activeProjects) || activeProjects.length === 0) {
    return null;
  }

  const sorted = [...activeProjects].sort((a, b) => (
    String(a.name || '').localeCompare(String(b.name || ''))
  ));

  if (storedProjectId && sorted.some((project) => String(project.id) === String(storedProjectId))) {
    return String(storedProjectId);
  }

  if (sorted.length === 1) {
    return String(sorted[0].id);
  }

  return String(sorted[0].id);
}

/**
 * @returns {string | null}
 */
export function readStoredProjectId() {
  try {
    const value = sessionStorage.getItem(USER_PROJECTS_CONTEXT_STORAGE_KEY);
    return value ? String(value) : null;
  } catch {
    return null;
  }
}

/**
 * @param {string | null} projectId
 */
export function writeStoredProjectId(projectId) {
  try {
    if (!projectId) {
      sessionStorage.removeItem(USER_PROJECTS_CONTEXT_STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(USER_PROJECTS_CONTEXT_STORAGE_KEY, String(projectId));
  } catch {
    // ignore storage failures
  }
}
